var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnWarning = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6562 11.3438V8.65625H10.3438V11.3438H11.6562ZM11.6562 14V12.6562H10.3438V14H11.6562ZM3.65625 16L11 3.34375L18.3438 16H3.65625Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-warning.8792c239.svg";
export { ForwardRef as ReactComponent };